import url from './apiUrl';
import handleResponse from "./handleResponse";

export default (token, user) => {

    return fetch(`${url()}/users/save`,{
            method: 'POST',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": token
            },
            body: JSON.stringify(user)
        })
        .then(res => handleResponse(res))
        .catch(err => console.log(err))
}